"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledControlButton = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var react_bootstrap_1 = require("react-bootstrap");
exports.StyledControlButton = (0, styled_components_1.default)(react_bootstrap_1.Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border: ", "\n    solid ", ";\n  box-shadow: 0 4px 8px 0 ", ";\n  line-height: 0;\n  padding: ", ";\n\n  &:disabled {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  &:not([disabled]):hover {\n    background-color: ", ";\n    border: ", "\n      solid ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n    background-color: ", ";\n    box-shadow:\n      0 0 0 3px ", ",\n      0 0 0 5px ", " !important;\n    position: relative;\n  }\n"], ["\n  background-color: ", ";\n  border: ", "\n    solid ", ";\n  box-shadow: 0 4px 8px 0 ", ";\n  line-height: 0;\n  padding: ", ";\n\n  &:disabled {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  &:not([disabled]):hover {\n    background-color: ", ";\n    border: ", "\n      solid ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n    background-color: ", ";\n    box-shadow:\n      0 0 0 3px ", ",\n      0 0 0 5px ", " !important;\n    position: relative;\n  }\n"])), function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Borders = _a.theme.Dimensions.Borders;
    return Borders.x1;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Shadows.light;
}, function (props) { return props.theme.Spacing.x1; }, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Borders = _a.theme.Dimensions.Borders;
    return Borders.x1;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
});
var templateObject_1;
